/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConclusionGroup
 */
export interface ConclusionGroup {
    /**
     * 
     * @type {number}
     * @memberof ConclusionGroup
     */
    conclusionGroupId?: number;
    /**
     * 
     * @type {number}
     * @memberof ConclusionGroup
     */
    assessmentExpressionId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConclusionGroup
     */
    conclusionText?: string;
}

/**
 * Check if a given object implements the ConclusionGroup interface.
 */
export function instanceOfConclusionGroup(value: object): value is ConclusionGroup {
    return true;
}

export function ConclusionGroupFromJSON(json: any): ConclusionGroup {
    return ConclusionGroupFromJSONTyped(json, false);
}

export function ConclusionGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConclusionGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'conclusionGroupId': json['conclusionGroupId'] == null ? undefined : json['conclusionGroupId'],
        'assessmentExpressionId': json['assessmentExpressionId'] == null ? undefined : json['assessmentExpressionId'],
        'conclusionText': json['conclusionText'] == null ? undefined : json['conclusionText'],
    };
}

export function ConclusionGroupToJSON(json: any): ConclusionGroup {
    return ConclusionGroupToJSONTyped(json, false);
}

export function ConclusionGroupToJSONTyped(value?: ConclusionGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conclusionGroupId': value['conclusionGroupId'],
        'assessmentExpressionId': value['assessmentExpressionId'],
        'conclusionText': value['conclusionText'],
    };
}

